import { classNames } from '../../utils/style-class.utils';
export var content = function (scrollable) {
    return "w-full ".concat(scrollable ? 'h-full overflow-y-auto' : '');
};
export var titleWrapper = 'inline-block py-2 pr-2 text-center z-0 w-10/12 justify-between';
export var titleSubWrapper = 'inline-flex flex-col';
export var iconWrapperLeft = 'w-4/12 flex justify-start';
export var iconWrapperRight = 'w-4/12 flex justify-end';
export var icons = 'cursor-pointer z-10 w-auto primaryAccent2';
export var menuIcons = 'cursor-pointer z-10 rounded-10 bg-primaryAccent1 h-10 w-10 p-2';
export var logo = 'text-center inline-block bg-logo mt-14 w-24 h-7 mb-12 bg-contain';
export var overlayImage = 'w-full';
export var header = function (showBackground, colour, size, renderBorder) {
    var baseClass = 'w-full flex flex-row relative justify-between items-center text-white py-4 px-4 z-10 ';
    switch (size) {
        case 'large':
            return classNames(showBackground ? 'bg-transparent' : "bg-".concat(colour), baseClass, renderBorder ? 'h-16' : 'h-116', renderBorder
                ? 'border-t-0 border-b border-uiMidDark border-r-0 border-l-0'
                : '');
        case 'medium':
            return classNames(baseClass, renderBorder ? 'h-16' : 'h-116', showBackground ? 'bg-transparent' : "bg-".concat(colour), renderBorder
                ? 'border-t-0 border-b border-uiMidDark border-r-0 border-l-0'
                : '');
        case 'smaller':
            return classNames(baseClass, renderBorder ? 'h-16' : 'h-16', showBackground ? 'bg-transparent' : "bg-".concat(colour), renderBorder
                ? 'border-t-0 border-b border-uiMidDark border-r-0 border-l-0'
                : '');
        case 'sub-normal':
            return classNames(baseClass, renderBorder ? 'h-16' : 'h-112', showBackground ? 'bg-transparent' : "bg-".concat(colour), renderBorder
                ? 'border-t-0 border-b border-uiMidDark border-r-0 border-l-0'
                : '');
        case 'normal':
            return classNames(baseClass, renderBorder ? 'h-16' : 'h-116', showBackground ? 'bg-transparent' : "bg-".concat(colour), renderBorder
                ? 'border-t-0 border-b border-uiMidDark border-r-0 border-l-0'
                : '');
        case 'small':
            return classNames(baseClass, 'h-16', showBackground ? 'bg-transparent' : "bg-".concat(colour), renderBorder
                ? 'border-t-0 border-b border-uiMidDark border-r-0 border-l-0'
                : '');
        case 'signup':
            return classNames(showBackground ? 'bg-transparent' : "bg-".concat(colour), baseClass, renderBorder ? 'h-16' : 'h-16', renderBorder
                ? 'border-t-0 border-b border-uiMidDark border-r-0 border-l-0'
                : '');
    }
};
export var backgroundWrapper = "w-full flex flex-col justify-start items-stretch relative z-10";
var baseBackgroundImageClass = 'w-full top-0 absolute z-0 overflow-hidden';
export var backgroundImageWrapper = function (size, backgroundImageColour) {
    switch (size) {
        case 'large':
            return classNames(baseBackgroundImageClass, 'h-244', "bg-".concat(backgroundImageColour));
        case 'signup':
            return classNames(baseBackgroundImageClass, 'h-244', "bg-".concat(backgroundImageColour));
        case 'medium':
            return classNames(baseBackgroundImageClass, 'h-40', "bg-".concat(backgroundImageColour));
        case 'sub-normal':
            return classNames(baseBackgroundImageClass, 'h-112', "bg-".concat(backgroundImageColour));
        case 'small':
            return classNames(baseBackgroundImageClass, 'h-40', "bg-".concat(backgroundImageColour));
        case 'smaller':
            return classNames(baseBackgroundImageClass, 'h-16', "bg-".concat(backgroundImageColour));
        case 'normal':
            return classNames(baseBackgroundImageClass, 'h-116', "bg-".concat(backgroundImageColour));
    }
};
export var offlineBadgeLarge = 'absolute z-50 top-102 left-1/2 transform -translate-x-1/2';
export var offlineBadgeSmall = 'absolute z-50 top-54 left-1/2 transform -translate-x-1/2';
export var backgroundWrapperOfflineBadge = function (size) {
    return size === 'large' ? offlineBadgeLarge : offlineBadgeSmall;
};
//# sourceMappingURL=banner-wrapper.styles.js.map